import { Button, Typography } from '@breetometer/components';

import type { IConfirmResetAction } from './PinManagement.helpers';

const ConfirmResetAction = ({ confirmAction, title, description, subDescription }: IConfirmResetAction) => (
	<div className='appresetpassword subbodycontent_main'>
		<Typography
			as='h3'
			className='color-neutral-50'
		>
			{title}
		</Typography>
		<div className='appresetpassword_notification'>
			<Typography
				as='span'
				className='color-primary-50'
			>
				{description}
			</Typography>
		</div>
		{subDescription && (
			<div className='appresetpassword_subnotification'>
				<Typography className='color-tertiary-400'>{subDescription}</Typography>
			</div>
		)}
		<div className='appresetpassword_confirm'>
			<Button
				label='Continue with Reset'
				onClick={confirmAction}
				className='primary-hover'
			/>
		</div>
	</div>
);

export default ConfirmResetAction;
